module.exports = __webpack_public_path__ + "static/media/woman_phone_car_wider.3e1f83b1.jpg";